import { render, staticRenderFns } from "./alertpass.vue?vue&type=template&id=1cc5c6e6"
import script from "./alertpass.vue?vue&type=script&lang=js"
export * from "./alertpass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports